/**
 * User-related Redux Actions
 */
/* tslint:disable:max-line-length */
import { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js';
import { PayloadError } from 'relay-runtime';
import actionCreatorFactory, { Action } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('User');

export type SetUserProfileAction = Action<ISetUserProfileActionPayload>;
export const setUserProfile = actionCreator<ISetUserProfileActionPayload>('SET_USER_PROFILE');
export const setViewerId = actionCreator<ISetViewerIdActionPayload>('SET_VIEWER_ID');
export const setUserLoginStatus = actionCreator<boolean>('SET_USER_LOGIN_STATUS');
export const setUserDetail = actionCreator<ISetUserDetailActionPayload>('SET_USER_DETAIL');
export const setCognitoUser = actionCreator<CognitoUser>('SET_COGNITO_USER');
export const setUserStripeToken = actionCreator<ISetUserStripeTokenActionPayload>('SET_USER_STRIPE_TOKEN');

// Request Async Actions
export const requestUpdateUserProfile = actionCreator<IRequestUpdateUserProfileActionPayload>('REQUEST_UPDATE_USER_PROFILE');
export const requestTrackUserRegistration = actionCreator<IRequestTrackUserRegistrationActionPayload>('REQUEST_TRACK_USER_REGISTRATION');
export const requestUserLogIn = actionCreator<IRequestUserAuthenticationActionPayload>('REQUEST_USER_LOG_IN');
export const requestUserLogOut = actionCreator<IRequestUserLogOutActionPayload>('REQUEST_USER_LOG_OUT');
export const requestUserSignUp = actionCreator<IRequestUserAuthenticationActionPayload>('REQUEST_USER_SIGN_UP');
export const requestResetPassword = actionCreator<IRequestResetPasswordActionPayload>('REQUEST_RESET_PASSWORD');
export const requestUserAuthenticationWithToken = actionCreator<IRequestUserTokenAuthenticationActionPayload>('REQUEST_USER_AUTHENTICATION_WITH_TOKEN');
export const requestSendConfirmationEmail = actionCreator<IPromiseActionPayload>('REQUEST_SEND_CONFIRMATION_EMAIL');
export const requestVerifyUserEmail = actionCreator<IRequestVerifyUserEmailActionPayload>('REQUEST_VERIFY_USER_EMAIL');

// Async Actions
export const logInUser = actionCreator.async<IUserCredentials, CognitoUserSession, Error>('LOG_IN_USER');
export const logOutUser = actionCreator.async<IViewerIdActionPayload, IMutationResult, Error>('LOG_OUT_USER');
export const signUpUser = actionCreator.async<IUserCredentials, CognitoUser, Error>('SIGN_UP_USER');
export const authenticateUserWithToken = actionCreator.async<IUserTokenAuthenticationActionPayload, any, Error>('AUTHENTICATE_USER_WITH_TOKEN');
export const resetPassword = actionCreator.async<IRequestResetPasswordActionPayload, void, Error>('RESET_PASSWORD');
export const updateUserProfile = actionCreator.async<IUpdateUserProfileActionPayload, PayloadError[] | null, Error>('UPDATE_USER_PROFILE');
export const trackNewUserRegistration = actionCreator.async<ITrackUserRegistrationPayload, PayloadError[] | null, Error>('TRACK_USER_REGISTRATION');
export const sendConfirmationEmail = actionCreator.async<void, void>('SEND_CONFIRMATION_EMAIL');
export const verifyUserEmail = actionCreator.async<IVerifyEmailActionPayload, IMutationResult>('VERIFY_USER_EMAIL');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/user.ts